var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
function _objectWithoutProperties(obj, keys) {
  var target = {};
  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }
  return target;
}
import React from "react";
export default (function (_ref) {
  var _ref$styles = _ref.styles,
    styles = _ref$styles === void 0 ? {} : _ref$styles,
    props = _objectWithoutProperties(_ref, ["styles"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50",
    height: "50",
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: "25",
    cy: "25",
    r: "25",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.5 14a10.51 10.51 0 0 0 0 21 10.51 10.51 0 0 0 0-21zm0 18.77a8.28 8.28 0 0 1 0-16.54 8.28 8.28 0 0 1 0 16.54z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.17 24.33h-3.51v-4.5a.83.83 0 0 0-.83-.83.83.83 0 0 0-.83.84v5.32c0 .47.37.84.83.84h4.34c.46 0 .83-.37.83-.84a.83.83 0 0 0-.83-.83z"
  }))));
});